// Global variables

// Header height ******************************************************
import { useHeaderHeight } from './hooks/useHeaderHeight';
import { useScreenWidth } from 'oolib';
import { getBreakPoint } from 'oolib';

export { useHeaderHeight };

// Layout Padding ******************************************************
/** @type {string} Desktop layout padding value right and left */
export const LayoutPadding = "2rem" // Desktop
/** @type {string} Mobile/tablet layout padding value right and left for screens smaller than md breakpoint */
export const LayoutPaddingMD = "1rem" // Mobile ,Tablet , Smaller screens ( < md )


// Would be useful to centralize and manage all z-index values for consistent UI layering

export const OKF_HEADER_ZINDEX = 10000
export const HamburgerMenu_ZINDEX = 10000
export const hamburgerMenu_backdrop_ZINDEX = 999

// Animation ******************************************************
/** Shared framer-motion spring config for collapse/expand animations */
export const SPRING = { type: "spring", stiffness: 400, damping: 40, mass: 1 };

// Service users ******************************************************
/**
 * Mirrors backend SERVICE_USER_PROFILE_TYPES (okf-be/serverUtils/SERVICE_USER_CONFIGS.js).
 * Platform-internal auth principals — must NEVER appear in any user-selectable
 * dropdown, filter, embed picker, or nav surface on the frontend.
 */
export const INTERNAL_SERVICE_PROFILE_TYPE = "internalServiceUsers";
export const EXTERNAL_SERVICE_PROFILE_TYPE = "externalServiceUsers";
export const SERVICE_USER_PROFILE_TYPES = Object.freeze([
  INTERNAL_SERVICE_PROFILE_TYPE,
  EXTERNAL_SERVICE_PROFILE_TYPE,
]);

/**
 * Mirrors backend EXTERNAL_SERVICE_USER_ROLE (okf-be/serverUtils/SERVICE_USER_CONFIGS.js).
 * The "External Service" role is dedicated to externalServiceUsers (machine-to-machine
 * auth principals) and must NEVER appear in any role picker, role filter, access-control
 * column, or role-list UI on the frontend.
 * (The internal service user uses role "superAdmin"; restricting that role is already
 * handled by isBlacklistedForAllButSuperAdmins.)
 */
export const EXTERNAL_SERVICE_USER_ROLE = "externalService";